import { compose } from "redux";
import {
  persistStore,
  persistReducer,
  PersistConfig,
  FLUSH,
  REHYDRATE,
  PAUSE,
  PERSIST,
  PURGE,
  REGISTER,
} from "redux-persist";
import storage from "redux-persist/lib/storage";
import { rootReducer } from "./root-reducer";
// import thunk from "redux-thunk";
import createSagaMiddleware from "redux-saga";
import { rootSaga } from "./root-saga";
import { configureStore } from "@reduxjs/toolkit";
import { PRODUCT_ACTION_TYPES } from "./product/product.types";

export type RootState = ReturnType<typeof rootReducer>;

declare global {
  interface Window {
    __REDUX_DEVTOOLS_EXTENSION_COMPOSE__?: typeof compose;
  }
}

type ExtendedPersistConfig = PersistConfig<RootState> & {
  whitelist: (keyof RootState)[];
};

const persistConfig: ExtendedPersistConfig = {
  key: "root",
  storage,
  whitelist: [
    "data",
    "user",
    "category",
    "brand",
    "attribute",
    "color",
    "blog",
    "theme",
    "support",
    "activity",
    "gallery",
    "order",
    "products",
  ],
};

const sagaMiddleware = createSagaMiddleware();

const persistedReducer = persistReducer(persistConfig, rootReducer);

// const useDevtool = process.env.NODE_ENV !== "production";

export const store = configureStore({
  reducer: persistedReducer, // Replace rootReducer with your actual rootReducer
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware({
      serializableCheck: {
        ignoredActions: [
          FLUSH,
          REHYDRATE,
          PAUSE,
          PERSIST,
          PURGE,
          REGISTER,
          PRODUCT_ACTION_TYPES.UPLOAD_PRODUCT,
        ],
      },
    }).concat(sagaMiddleware),
  devTools: true,
});

sagaMiddleware.run(rootSaga);
export const persistor = persistStore(store);

// Inferred type: {posts: PostsState, comments: CommentsState, users: UsersState}
export type AppDispatch = typeof store.dispatch;
